module.exports = __webpack_public_path__ + "static/img/114.116.12.146.57369385.png";